import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('autoapproval_step_1'),
    removeStepTitle: defineMessage('remove_autoapproval_step'),
    settingsButton: defineMessage('autoapproval_settings'),
    note: defineMessage('please_note_the_autoapp__further_approval_steps'),
    willBeApprovedAutomaticallyIf: defineMessage('requesttype_will_be_approved_automatically_if'),
    and: defineMessage('and'),
    or: defineMessage('or'),
};
